import { FC, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from '../../hooks/redux'
import { Modal } from '../../components/modal/modal'
import { Checkbox } from '../../components/checkbox/checkbox'
import { CustomButton } from '../../components/customButton'
import { getVoices } from '../../store/slices/tts/async'
import { updateVoiceGroup } from '../../store/slices/voiceGroups/async'
import { TGroup } from './groupsTab'
import classes from '../../styles/voices/addVoiceModal.module.scss'

interface AddVoiceModalProps {
  group: TGroup
  onClose: () => void
}

export const AddVoiceModal: FC<AddVoiceModalProps> = ({ group, onClose }) => {
  const dispatch = useDispatch()
  const allVoices = useSelector((state) => state.tts.voices)
  const groups = useSelector((state) => state.voiceGroups.groups)
  const [selected, setSelected] = useState<string[]>([])
  const [search, setSearch] = useState('')

  useEffect(() => {
    if (allVoices.length === 0) dispatch(getVoices() as any)
  }, [])

  const toggle = (name: string) => {
    setSelected((prev) =>
      prev.includes(name) ? prev.filter((v) => v !== name) : [...prev, name]
    )
  }

  const currentVoiceNames = groups
    .find((g) => String(g.voice_group_id) === group.value)
    ?.voices.map((v) => v.technical_name) ?? []

  const filtered = allVoices.filter((v) =>
    v.name.toLowerCase().includes(search.toLowerCase())
  )

  const handleAdd = () => {
    const merged = Array.from(new Set([...currentVoiceNames, ...selected]))
    dispatch(updateVoiceGroup({ voice_group_id: Number(group.value), voices: merged }) as any)
    onClose()
  }

  return (
    <Modal isOpen title="Добавить голос" handleClose={onClose} classes={{ modalContent: classes.modal }}>
      <div className={classes.wrapper}>
        <div className={classes.groupHeader}>
          <span className={classes.groupName}>{group.name}</span>
          <span className={classes.groupCount}>{group.count} голосов</span>
        </div>

        <div className={classes.search}>
          <input
            className={classes.searchInput}
            placeholder="Поиск голоса"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className={classes.list}>
          {filtered.map((voice, i) => {
            const alreadyIn = currentVoiceNames.includes(voice.name)
            return (
              <div
                key={i}
                className={`${classes.voiceItem} ${selected.includes(voice.name) ? classes.voiceItemSelected : ''} ${alreadyIn ? classes.voiceItemAlready : ''}`}
                onClick={() => toggle(voice.name)}
              >
                <span onClick={(e) => e.stopPropagation()}>
                  <Checkbox
                    isChecked={selected.includes(voice.name) || alreadyIn}
                    handleCheckboxChange={() => toggle(voice.name)}
                  />
                </span>
                <span className={classes.voiceName}>{voice.title || voice.name}</span>
                {alreadyIn && <span className={classes.voiceAlreadyLabel}>уже в группе</span>}
                {!alreadyIn && voice.languages?.[0] && <span className={classes.voiceLang}>{voice.languages[0]}</span>}
              </div>
            )
          })}
        </div>

        <div className={classes.footer}>
          <CustomButton className={classes.footerCancel} onClick={onClose}>Отменить</CustomButton>
          <CustomButton className={classes.footerApply} onClick={handleAdd}>
            Добавить{selected.length > 0 ? ` (${selected.length})` : ''}
          </CustomButton>
        </div>
      </div>
    </Modal>
  )
}
